// CRM-W1 (2026-05-25) — 바이어 상담/연락 이력 모달
// API: GET/POST/DELETE /buyers/:id/interactions, PATCH .../followup-done

import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';

var TYPE_LABEL = { call: '📞 전화', email: '✉️ 이메일', meeting: '🤝 미팅', memo: '📝 메모' };

function fmtDate(s) {
  if (!s) return '';
  return String(s).slice(0, 16).replace('T', ' ');
}

function BuyerCRMModal(props) {
  var buyerId = props.buyerId;
  var buyerName = props.buyerName;
  var onClose = props.onClose;
  var showToast = props.showToast;

  var [items, setItems] = useState([]);
  var [type, setType] = useState('call');
  var [content, setContent] = useState('');
  var [followUp, setFollowUp] = useState('');
  var [busy, setBusy] = useState(false);
  var [tab, setTab] = useState('log');          // CRM-W3: log | timeline
  var [timeline, setTimeline] = useState([]);
  var [summary, setSummary] = useState(null);

  function load() {
    authFetch(API + '/buyers/' + buyerId + '/interactions')
      .then(function(r) { return r.json(); })
      .then(function(d) { if (d && d.success) setItems(d.data || []); })
      .catch(function() {});
  }

  function loadTimeline() {
    authFetch(API + '/buyers/' + buyerId + '/timeline')
      .then(function(r) { return r.json(); })
      .then(function(d) { if (d && d.success) { setTimeline(d.data || []); setSummary(d.summary || null); } })
      .catch(function() {});
  }

  useEffect(function() { load(); }, [buyerId]);
  useEffect(function() { if (tab === 'timeline') loadTimeline(); }, [tab, buyerId]);

  function add() {
    if (!content.trim() && !followUp) {
      showToast && showToast('내용 또는 팔로업 일자를 입력하세요', 'error');
      return;
    }
    setBusy(true);
    authFetch(API + '/buyers/' + buyerId + '/interactions', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ type: type, content: content, follow_up_at: followUp || null })
    })
      .then(function(r) { return r.json(); })
      .then(function(d) {
        if (d && d.success) { setContent(''); setFollowUp(''); load(); showToast && showToast('기록 추가', 'success'); }
        else showToast && showToast((d && d.error) || '실패', 'error');
      })
      .catch(function() { showToast && showToast('네트워크 오류', 'error'); })
      .finally(function() { setBusy(false); });
  }

  function del(id) {
    if (!window.confirm('이 기록을 삭제할까요?')) return;
    authFetch(API + '/buyers/' + buyerId + '/interactions/' + id, { method: 'DELETE' })
      .then(function(r) { return r.json(); })
      .then(function(d) { if (d && d.success) load(); });
  }

  function doneFollowup(id) {
    authFetch(API + '/buyers/' + buyerId + '/interactions/' + id + '/followup-done', { method: 'PATCH' })
      .then(function(r) { return r.json(); })
      .then(function(d) { if (d && d.success) load(); });
  }

  var ls = { display: 'block', fontSize: 11, fontWeight: 600, color: '#64748b', marginBottom: 4, marginTop: 10 };
  var is = { width: '100%', padding: '8px 10px', border: '1px solid #d0d5dd', borderRadius: 8, fontSize: 13, outline: 'none', boxSizing: 'border-box' };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }} onClick={onClose}>
      <div style={{ background: '#fff', borderRadius: 12, width: 560, maxWidth: '92vw', maxHeight: '88vh', overflow: 'auto', padding: 24 }} onClick={function(e) { e.stopPropagation(); }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <h3 style={{ margin: 0 }}>📋 {buyerName}</h3>
          <button onClick={onClose} style={{ border: 'none', background: 'none', fontSize: 20, cursor: 'pointer', color: '#94a3b8' }}>✕</button>
        </div>

        {/* 탭 */}
        <div style={{ display: 'flex', gap: 8, marginBottom: 14, borderBottom: '1px solid #eef2f7' }}>
          <button onClick={function() { setTab('log'); }} style={{ border: 'none', background: 'none', padding: '6px 4px', borderBottom: tab === 'log' ? '2px solid #1B3A5C' : '2px solid transparent', fontWeight: tab === 'log' ? 800 : 500, color: tab === 'log' ? '#1B3A5C' : '#94a3b8', cursor: 'pointer', fontSize: 13 }}>상담 이력</button>
          <button onClick={function() { setTab('timeline'); }} style={{ border: 'none', background: 'none', padding: '6px 4px', borderBottom: tab === 'timeline' ? '2px solid #1B3A5C' : '2px solid transparent', fontWeight: tab === 'timeline' ? 800 : 500, color: tab === 'timeline' ? '#1B3A5C' : '#94a3b8', cursor: 'pointer', fontSize: 13 }}>거래 타임라인</button>
        </div>

        {tab === 'timeline' ? (
          <div>
            {summary && (
              <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
                <div style={{ flex: 1, background: '#f7f9fc', borderRadius: 8, padding: '8px 10px', fontSize: 12 }}>입금 합계<br/><b style={{ fontSize: 15, color: '#1B3A5C' }}>₩{Math.round((summary.totalDepositKrw || 0) / 10000).toLocaleString()}만</b></div>
                <div style={{ flex: 1, background: '#f7f9fc', borderRadius: 8, padding: '8px 10px', fontSize: 12 }}>인보이스<br/><b style={{ fontSize: 15, color: '#1B3A5C' }}>{summary.invoiceCount}건</b></div>
                <div style={{ flex: 1, background: '#f7f9fc', borderRadius: 8, padding: '8px 10px', fontSize: 12 }}>상담<br/><b style={{ fontSize: 15, color: '#1B3A5C' }}>{summary.interactionCount}건</b></div>
              </div>
            )}
            {timeline.length === 0 ? (
              <div style={{ textAlign: 'center', color: '#94a3b8', padding: 24, fontSize: 13 }}>거래 이력이 없습니다</div>
            ) : timeline.map(function(ev, idx) {
              var icon = ev.kind === 'deposit' ? '💰' : (ev.kind === 'invoice' ? '📄' : (TYPE_LABEL[ev.type] || '📝').split(' ')[0]);
              var detail = ev.kind === 'deposit' ? ('입금 ₩' + Math.round((ev.amount_krw || 0) / 10000).toLocaleString() + '만')
                : (ev.kind === 'invoice' ? ('인보이스 · ' + (ev.status || '')) : (ev.label || ''));
              return (
                <div key={idx} style={{ display: 'flex', gap: 10, padding: '8px 0', borderBottom: '1px solid #f8fafc' }}>
                  <span style={{ fontSize: 16 }}>{icon}</span>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 13, color: '#0f172a' }}>{detail}</div>
                    <div style={{ fontSize: 11, color: '#94a3b8' }}>{fmtDate(ev.date)}</div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
        <div>
        {/* 추가 폼 */}
        <div style={{ background: '#f7f9fc', borderRadius: 8, padding: 14, marginBottom: 16 }}>
          <div style={{ display: 'flex', gap: 8 }}>
            <select value={type} onChange={function(e) { setType(e.target.value); }} style={{ ...is, width: 110 }}>
              <option value="call">📞 전화</option>
              <option value="email">✉️ 이메일</option>
              <option value="meeting">🤝 미팅</option>
              <option value="memo">📝 메모</option>
            </select>
            <input style={is} placeholder="상담 내용" value={content} onChange={function(e) { setContent(e.target.value); }} />
          </div>
          <label style={ls}>팔로업 예정일 (선택)</label>
          <input type="date" style={is} value={followUp} onChange={function(e) { setFollowUp(e.target.value); }} />
          <button onClick={add} disabled={busy} style={{ marginTop: 10, width: '100%', padding: '10px', background: '#1B3A5C', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: busy ? 'not-allowed' : 'pointer' }}>
            기록 추가
          </button>
        </div>

        {/* 이력 목록 */}
        {items.length === 0 ? (
          <div style={{ textAlign: 'center', color: '#94a3b8', padding: 24, fontSize: 13 }}>상담 이력이 없습니다</div>
        ) : (
          items.map(function(it) {
            var overdue = it.follow_up_at && !it.follow_up_done && it.follow_up_at <= new Date().toISOString().slice(0, 10);
            return (
              <div key={it.id} style={{ borderBottom: '1px solid #eef2f7', padding: '10px 0', display: 'flex', justifyContent: 'space-between', gap: 10 }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: '#0f172a' }}>{TYPE_LABEL[it.type] || it.type} {it.content}</div>
                  <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>
                    {fmtDate(it.created_at)}
                    {it.follow_up_at && (
                      <span style={{ marginLeft: 8, color: it.follow_up_done ? '#16a34a' : (overdue ? '#dc2626' : '#2563eb'), fontWeight: 700 }}>
                        · 팔로업 {it.follow_up_at}{it.follow_up_done ? ' ✓' : (overdue ? ' (지연)' : '')}
                      </span>
                    )}
                  </div>
                </div>
                <div style={{ flex: '0 0 auto', display: 'flex', gap: 4, alignItems: 'flex-start' }}>
                  {it.follow_up_at && !it.follow_up_done && (
                    <button onClick={function() { doneFollowup(it.id); }} title="팔로업 완료" style={{ border: '1px solid #16a34a', background: '#fff', color: '#16a34a', borderRadius: 4, fontSize: 11, padding: '2px 6px', cursor: 'pointer' }}>완료</button>
                  )}
                  <button onClick={function() { del(it.id); }} title="삭제" style={{ border: 'none', background: 'none', color: '#cbd5e1', fontSize: 14, cursor: 'pointer' }}>🗑</button>
                </div>
              </div>
            );
          })
        )}
        </div>
        )}
      </div>
    </div>
  );
}

export default BuyerCRMModal;
